export function getTaskSubject(subject) {
  if (subject === 'Assign Practice') {
    return 'At Home Review';
  }

  return subject;
}

export function getTaskLink(taskType, params) {
  console.log(taskType);
  console.log(params);
}



// WEBPACK FOOTER //
// ./data/Tasks/accessors.js